"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = readableColor;

var _luminanceThreshold = _interopRequireDefault(require("./luminanceThreshold"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var theNewBlack = '#212121'; // jane said this will NEVER change so i'm okay with this hard-code

function readableColor(color) {
  if ((0, _luminanceThreshold["default"])(color)) return theNewBlack;
  return '#fff';
}